import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { IonicModule } from '@ionic/angular';


import { HeaderToolbarComponent } from "../header-toolbar/header-toolbar.component";
import { HeaderToolbarEmptyComponent } from "../header-toolbar-empty/header-toolbar-empty.component";
import { SearchBarArticleComponent } from "../search-bar-article/search-bar-article.component";
import { OpenableModalToolbarEmptyComponent } from "../openable-modal-toolbar-empty/openable-modal-toolbar-empty.component";
import {OpenMenuComponent} from "../open-menu/open-menu.component";
import {NotificationBadgeComponent} from "../notification-badge/notification-badge.component";
import {HeaderToolbarModalLocationComponent} from "../header-toolbar-modal-location/header-toolbar-modal-location.component";
import { SafePipe } from '../doctorprofile/pipeSafe';
import { SearchBarDoctorComponent } from '../search-bar-doctor/search-bar-doctor.component';
import { SearchBarDoctorArrayComponent } from '../search-bar-doctor-array/search-bar-doctor.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        TranslateModule
    ],
    declarations: [HeaderToolbarComponent,HeaderToolbarEmptyComponent,SearchBarArticleComponent,OpenMenuComponent,HeaderToolbarModalLocationComponent,SafePipe,OpenableModalToolbarEmptyComponent, NotificationBadgeComponent, SearchBarDoctorComponent, SearchBarDoctorArrayComponent], 
    exports:[HeaderToolbarComponent,HeaderToolbarEmptyComponent,SearchBarArticleComponent,OpenMenuComponent,HeaderToolbarModalLocationComponent,SafePipe, OpenableModalToolbarEmptyComponent,NotificationBadgeComponent, SearchBarDoctorComponent, SearchBarDoctorArrayComponent] 
})
export class CustomModule {}
